import React from "react";

interface WhiteboardPhotoFrameProps extends React.HTMLAttributes<HTMLDivElement> {
  controls?: React.ReactNode;
  contentClassName?: string;
  appearance?: "photo" | "study";
  paginated?: boolean;
}

export const WHITEBOARD_FOCUSED_FRAME_CLASS =
  "h-[min(76dvh,42rem)] w-full max-w-6xl shadow-2xl shadow-black/55 sm:aspect-[2048/1056] sm:h-auto";

export const WHITEBOARD_INLINE_FRAME_CLASS =
  "h-[min(58dvh,30rem)] w-full shadow-xl shadow-black/40 sm:aspect-[2048/1056] sm:h-auto";

export function WhiteboardPhotoFrame({
  children,
  controls,
  className = "",
  contentClassName = "",
  appearance = "photo",
  paginated = false,
  ...props
}: WhiteboardPhotoFrameProps) {
  return (
    <div
      className={`${appearance === "study" ? "bg-[#0F0F14]" : "whiteboard-photo-shell bg-[url('/ui/Whiteboard_background.png')] bg-cover bg-center"} relative mx-auto overflow-hidden rounded-xl ${className}`}
      {...props}
    >
      {controls ? (
        <div
          className="absolute z-30 flex items-center gap-1.5"
          style={{
            right: "clamp(0.75rem, 3%, 1.5rem)",
            top: "clamp(0.75rem, 4%, 1.5rem)",
          }}
          data-testid="whiteboard-presentation-controls"
        >
          {controls}
        </div>
      ) : null}
      <div
        className={`${appearance === "study" ? "absolute inset-0 px-1 pb-1 pt-14" : "absolute bottom-[13%] left-[7%] right-[5.5%] top-[13%] px-2 py-1 sm:bottom-[12%] sm:left-[8%] sm:right-[6%] sm:top-[14%] sm:px-4 sm:py-2"} ${paginated ? "overflow-hidden" : "overflow-y-auto"} ${contentClassName}`}
      >
        {children}
      </div>
    </div>
  );
}
